<template></template>

<script setup lang="ts">
import { useRouter } from "vue-router";
import { onBeforeMount, ref, type Ref } from "vue";
import _ from "lodash";
import MasterService from "@/service/restfulService/CCOnboardMasterService";
import type FormBundlingValidation from "@/interface/FormBundlingValidation";
import type MultiChannelLink from "@/interface/MultiChannelLink";
import type CardType from "@/interface/CardType";
import Constants from "@/constants/constants";

// http://localhost:5173/cc-onboard/webform/apply/request?cc=NA&type=BIO

// http://localhost:5173/cc-onboard/webform/apply/request?webFormRequestId=ae1f7305-d8c9-4e47-b501-d870ba76b2b0
// http://localhost:5173/cc-onboard/webform/apply/request?webFormRequestId=c8a6d61b-ec68-4058-a117-d22a720a6364

// http://localhost:5173/cc-onboard/webform/apply/request?cc=M3

// http://localhost:5173/cc-onboard/webform/apply/request?webFormRequestId=a5c94a7a-f103-41ac-a643-41ee9bf921c2
// http://localhost:5173/cc-onboard/webform/apply/request?webFormRequestId=79017e69-af11-4096-9c11-f87c1284488c

//Valid Channel- Not Valid CPC
//CPC = Card Product Code
// http://localhost:5173/cc-onboard/webform/apply/request?ACC=B1&BC=BC1&RCI=RCI1&CPC=NA&MCI=MCI1&MC=MC1&CRFN=CRFN1

//Invalid Channel- Not Valid CPC
// http://localhost:5173/cc-onboard/webform/apply/request?ACC=TEST&BC=BC1&RCI=RCI1&CPC=NA&MCI=MCI1&MC=MC1&CRFN=CRFN1

//Valid Product Code
// http://localhost:5173/cc-onboard/webform/apply/request?acc=b1&BC=0117&RCI=rci1&cpc=M3&MCI=na&MC=na&CRFN=na

//Invalid Product Code
// http://localhost:5173/cc-onboard/webform/apply/request?ACC=B1&BC=BC1&RCI=RCI1&CPC=abc&MCI=MCI1&MC=MC1&CRFN=CRFN1

//M1
// http://localhost:5173/cc-onboard/webform/apply/request?ACC=M1&BC=0101&RCI=NA&CPC=NA&MCI=NA&MC=0005659-001&CRFN=NA

const router = useRouter();
const draftListing = history.state.draftListing
  ? history.state.draftListing
  : false;
const resumedByRecruiterId = history.state.resumedByRecruiterId
  ? history.state.resumedByRecruiterId
  : "";
const resumedByRecruiterName = history.state.resumedByRecruiterName
  ? history.state.resumedByRecruiterName
  : "";
const comeFromReminderLink = history.state.comeFromReminderLink
  ? history.state.comeFromReminderLink
  : false;
const isAutoPopulate = history.state.isAutoPopulate
  ? history.state.isAutoPopulate
  : false;

const cardId = ref<string>("");
const type = ref<string>("");
const webFormRequestId = ref<string>("");
const requestModel = ref<FormBundlingValidation>({
  webFormRequestId: "",
});
const multiChannelRequestModel = ref<MultiChannelLink>({
  acc: "",
  bc: "",
  rci: "",
  cpc: "",
  mci: "",
  mc: "",
  crfn: "",
});
//Multi Channel
const paramNames = ["ACC", "BC", "RCI", "CPC", "MCI", "MC", "CRFN"];

const cardTypeList: Ref<CardType[]> = ref([]);

const setValueToInterface = () => {
  requestModel.value.webFormRequestId = webFormRequestId.value.toLowerCase();
};

const parseQueryString = () => {
  const currentUrl = window.location.href;
  const params = new URLSearchParams(window.location.search);

  const updatedParams = new URLSearchParams();
  params.forEach((value, key) => {
    const uppercasedValue = value.toUpperCase();
    updatedParams.set(key.toUpperCase(), uppercasedValue);
  });

  function areAllParamsPresent(
    paramNames: string[],
    params: URLSearchParams,
  ): boolean {
    return paramNames.every(
      (param) => params.has(param) && params.get(param)?.trim() !== "",
    );
  }
  if (updatedParams.has("CC") && !updatedParams.has("TYPE")) {
    cardId.value = updatedParams.get("CC") || "";

    // Create a URL object
    const url = new URL(currentUrl);
    url.search = "";
    // Update the CPC parameter
    url.searchParams.set("cc", cardId.value.toUpperCase());

    if (cardId.value == "") {
      // window.close;
      router.push({
        name: "CCOnboard",
        state: { url: url.toString(), error: ["Invalid Card Product Code"] },
        query: { cc: "NA" },
      });
    } else if (cardId.value == "NA") {
      router.push({
        name: "CCOnboard",
        state: { url: url.toString() },
        query: { cc: "NA" },
      });
    } else {
      MasterService.cardType().then((res) => {
        cardTypeList.value = res.data.responseModel.cardTypeList;
        const cardObject = cardTypeList.value.find(
          (cardType) => cardType.code === cardId.value.toUpperCase(),
        );

        if (cardObject) {
          router.push({
            name: "CCOnboard",
            state: { url: url.toString() },
            query: { cc: cardId.value.toUpperCase() },
          });
        } else {
          router.push({
            name: "Acknowledgement",
            query: {
              status: "cardTypeMissing",
              refNo: "",
            },
          });
        }
      });
    }
  } else if (
    updatedParams.has("WEBFORMREQUESTID") &&
    !updatedParams.has("CC")
  ) {
    webFormRequestId.value = updatedParams.get("WEBFORMREQUESTID") || "";
    if (webFormRequestId.value != "") {
      webFormRequestId.value = webFormRequestId.value.toLowerCase();
      setValueToInterface();

      if (draftListing) {
        const requestModel = {
          webFormRequestId: webFormRequestId.value,
        };
        MasterService.generateToken(requestModel)
          .then((res) => {
            if (res.status == 200) {
              const token = res.data.responseModel.token;
              MasterService.validate(requestModel, token)
                .then((res) => {
                  if (res.status == 200) {
                    const expiredType =
                      res.data?.responseModel?.cardList?.[0]
                        ?.productBundlingExpiredtype;
                    if (
                      comeFromReminderLink ||
                      ["PF_CC", "EP_CC"].includes(expiredType)
                    ) {
                      router.push({
                        name: "CCOnboard",
                        state: {
                          reminderValue: res.data.responseModel.cardList[0],
                          isDraft: true,
                          type: res.data.responseModel.cardList[0].type,
                          webFormRequestId: webFormRequestId.value,
                          token: token,
                        },
                        query: {
                          webFormRequestId: webFormRequestId.value,
                        },
                      });
                    } else if (
                      res.data.responseModel.cardList[0].type == "CC"
                    ) {
                      router.push({
                        name: "CCOnboard",
                        state: {
                          reminderValue: res.data.responseModel.cardList[0],
                          isDraft: isAutoPopulate ? false : true,
                          type: res.data.responseModel.cardList[0].type,
                          webFormRequestId: webFormRequestId.value,
                          token: token,
                          isAutoPopulate: isAutoPopulate,
                          resumedByRecruiterId: resumedByRecruiterId,
                          resumedByRecruiterName: resumedByRecruiterName,
                        },
                        query: {
                          cc: res.data.responseModel.cardList[0].cardId
                            ? res.data.responseModel.cardList[0].cardId
                            : "NA",
                        },
                      });
                    } else if (
                      res.data.responseModel.cardList[0].type == "MC"
                    ) {
                      router.push({
                        name: "CCOnboard",
                        state: {
                          reminderValue: res.data.responseModel.cardList[0],
                          isDraft: isAutoPopulate ? false : true,
                          type: res.data.responseModel.cardList[0].type,
                          webFormRequestId: webFormRequestId.value,
                          token: token,
                          isAutoPopulate: isAutoPopulate,
                          resumedByRecruiterId: resumedByRecruiterId,
                          resumedByRecruiterName: resumedByRecruiterName,
                        },
                        query: {
                          ACC: res.data.responseModel.cardList[0]
                            .applicationChannelCode
                            ? res.data.responseModel.cardList[0]
                                .applicationChannelCode
                            : "NA",
                          BC: res.data.responseModel.cardList[0].branchCode
                            ? res.data.responseModel.cardList[0].branchCode
                            : "NA",
                          RCI: res.data.responseModel.cardList[0].recruiterId
                            ? res.data.responseModel.cardList[0].recruiterId
                            : "NA",
                          CPC: res.data.responseModel.cardList[0]
                            .cardProductCode
                            ? res.data.responseModel.cardList[0].cardProductCode
                            : "NA",
                          MCI: res.data.responseModel.cardList[0]
                            .marketingCampaignId
                            ? res.data.responseModel.cardList[0]
                                .marketingCampaignId
                            : "NA",
                          MC: res.data.responseModel.cardList[0].merchantCode
                            ? res.data.responseModel.cardList[0].merchantCode
                            : "NA",
                          CRFN: res.data.responseModel.cardList[0].crmRefNumber
                            ? res.data.responseModel.cardList[0].crmRefNumber
                            : "NA",
                        },
                      });
                    } else if (
                      res.data.responseModel.cardList[0].type == "BIO" &&
                      !res.data.responseModel.cardList[0].biometricVerification
                    ) {
                      router.push({
                        name: "CCOnboard",
                        state: {
                          reminderValue: res.data.responseModel.cardList[0],
                          isDraft: isAutoPopulate ? false : true,
                          type: res.data.responseModel.cardList[0].type,
                          webFormRequestId: webFormRequestId.value,
                          token: token,
                          isAutoPopulate: isAutoPopulate,
                          resumedByRecruiterId: resumedByRecruiterId,
                          resumedByRecruiterName: resumedByRecruiterName,
                        },
                        query: {
                          cc: res.data.responseModel.cardList[0].cardId
                            ? res.data.responseModel.cardList[0].cardId
                            : "NA",
                          type: res.data.responseModel.cardList[0].type,
                        },
                      });
                    } else if (
                      res.data.responseModel.cardList[0].type == "BIO" &&
                      res.data.responseModel.cardList[0].biometricVerification
                    ) {
                      router.push({
                        name: "CCOnboard",
                        state: {
                          reminderValue: res.data.responseModel.cardList[0],
                          isDraft: isAutoPopulate ? false : true,
                          type: res.data.responseModel.cardList[0].type,
                          webFormRequestId: webFormRequestId.value,
                          token: token,
                          isAutoPopulate: isAutoPopulate,
                          resumedByRecruiterId: resumedByRecruiterId,
                          resumedByRecruiterName: resumedByRecruiterName,
                        },
                        query: {
                          webFormRequestId: webFormRequestId.value,
                        },
                      });
                    } else if (
                      res.data.responseModel.cardList[0].type == "CR_SL" ||
                      res.data.responseModel.cardList[0].type == "FINPLUS"
                    ) {
                      router.push({
                        name: "CCOnboard",
                        state: {
                          reminderValue: res.data.responseModel.cardList[0],
                          isDraft: isAutoPopulate ? false : true,
                          type: res.data.responseModel.cardList[0].type,
                          webFormRequestId: webFormRequestId.value,
                          token: token,
                          isAutoPopulate: isAutoPopulate,
                          resumedByRecruiterId: resumedByRecruiterId,
                          resumedByRecruiterName: resumedByRecruiterName,
                        },
                        query: {
                          webFormRequestId: webFormRequestId.value,
                        },
                      });
                    }
                  }
                })
                .catch((e) => {
                  router.push({
                    name: "Acknowledgement",
                    query: {
                      status: "cardTypeMissing",
                      refNo: "",
                    },
                  });
                });
            }
          })
          .catch((e) => {
            router.push({
              name: "Acknowledgement",
              query: {
                status: "cardTypeMissing",
                refNo: "",
              },
            });
          });
      } else {
        MasterService.linkValidate(requestModel.value, webFormRequestId.value)
          .then((res) => {
            if (res.status == 200) {
              const type = res.data.responseModel.type;
              const status = res.data.responseModel.status;
              // browser refresh button handling
              if (window.performance.navigation.type === 1) {
                if (type == "BIO") {
                  router
                    .push({
                      name: "CCOnboard",
                      state: {
                        type: "BIO",
                      },
                      query: { cc: localStorage.getItem("cardId"), type: type },
                    })
                    .then(() => {
                      setTimeout(() => {
                        window.location.reload(); // true forces a reload from the server
                      }, 100);
                    });
                } else if (
                  type == "CC" ||
                  type == "PF_CC" ||
                  type == "EP_CC" ||
                  type == "FINPLUS"
                ) {
                  router
                    .push({
                      name: "CCOnboard",
                      query: { cc: localStorage.getItem("cardId") },
                    })
                    .then(() => {
                      setTimeout(() => {
                        window.location.reload(); // true forces a reload from the server
                      }, 100);
                    });
                } else if (type == "CR_SL") {
                  router
                    .push({
                      name: "CCOnboard",
                      query: {
                        ACC: "W1",
                        BC: "0101",
                        RCI: "NA",
                        CPC: "NA",
                        MCI: "NA",
                        MC: "NA",
                        CRFN: "NA",
                      },
                    })
                    .then(() => {
                      setTimeout(() => {
                        window.location.reload(); // true forces a reload from the server
                      }, 100);
                    });
                }
              } else {
                if (status == "EXPIRY") {
                  router.push({
                    name: "Acknowledgement",
                    query: {
                      status: "expiredReminderLink",
                      refNo: res.data.responseModel.refNo,
                      type: res.data.responseModel.type,
                    },
                  });
                } else if (status == "FAILED") {
                  router.push({
                    name: "Acknowledgement",
                    query: {
                      status: "invalidLink",
                      refNo: res.data.responseModel.refNo,
                      type: res.data.responseModel.type,
                    },
                  });
                } else if (status == "COMPLETE") {
                  router.push({
                    name: "Acknowledgement",
                    query: {
                      status: "success",
                      refNo: res.data.responseModel.refNo,
                      type: res.data.responseModel.type,
                    },
                  });
                } else {
                  const reminder = res.data.responseModel.reminder;
                  const bioCardList =
                    res.data.responseModel.biometricCardList[0] != undefined
                      ? res.data.responseModel.biometricCardList[0]
                      : "";
                  const cardList = res.data.responseModel.cardList
                    ? res.data.responseModel.cardList[0]
                    : "";
                  const requestModel = {
                    webFormRequestId: webFormRequestId.value,
                  };
                  const refNo = res.data.responseModel.refNo;
                  const remainingTime = res.data.responseModel.remainingTime;

                  if (status == "PENDING" && !reminder) {
                    router.push({
                      name: "Acknowledgement",
                      query: {
                        status: "invalidReminderLink",
                        refNo: refNo,
                        type: type,
                      },
                    });
                  } else {
                    MasterService.generateToken(requestModel)
                      .then((res) => {
                        if (res.status == 200) {
                          const token = res.data.responseModel.token;

                          // Access link first time - Reminder or EPCC timeout
                          if (
                            reminder ||
                            (type == "CC" &&
                              cardList &&
                              cardList.productBundlingExpiredtype == "EP_CC")
                          ) {
                            const requestModel = {
                              webFormRequestId: webFormRequestId.value,
                            };
                            MasterService.validate(requestModel, token)
                              .then((res) => {
                                if (res.status == 200) {
                                  if (reminder) {
                                    // reminder link
                                    router.push({
                                      name: "CCOnboard",
                                      state: {
                                        reminderValue:
                                          res.data.responseModel.cardList[0],
                                        isReminder: true,
                                        type: type,
                                        webFormRequestId:
                                          webFormRequestId.value,
                                        token: token,
                                      },
                                      query: {
                                        webFormRequestId:
                                          webFormRequestId.value,
                                      },
                                    });
                                  } else {
                                    router.push({
                                      name: "CCOnboard",
                                      state: {
                                        reminderValue:
                                          res.data.responseModel.cardList[0],
                                        isDraft: true,
                                        type: res.data.responseModel.cardList[0]
                                          .type,
                                        webFormRequestId:
                                          webFormRequestId.value,
                                        token: token,
                                      },
                                      query: {
                                        webFormRequestId:
                                          webFormRequestId.value,
                                      },
                                    });
                                  }
                                }
                              })
                              .catch((e) => {
                                router.push({
                                  name: "Acknowledgement",
                                  query: {
                                    status: "cardTypeMissing",
                                    refNo: "",
                                  },
                                });
                              });
                          } else {
                            // product bundling flow
                            if (
                              (type == "PF_CC" || type == "EP_CC") &&
                              status == "INIT"
                            ) {
                              router.push({
                                name: "CCOnboard",
                                state: {
                                  value: cardList,
                                  type: type,
                                  token: token,
                                  remainingTime: remainingTime,
                                },
                                query: {
                                  webFormRequestId: webFormRequestId.value,
                                },
                              });
                            }
                            // biometric flow
                            else if (type == "BIO" && status == "INIT") {
                              router.push({
                                name: "CCOnboard",
                                state: {
                                  biometricValue: bioCardList,
                                  refNo: refNo,
                                  type: type,
                                  token: token,
                                },
                                query: {
                                  webFormRequestId: webFormRequestId.value,
                                },
                              });
                            }
                            // Cross Selling and Finplus flow
                            else if (
                              (type == "CR_SL" || type == "FINPLUS") &&
                              status == "INIT"
                            ) {
                              router.push({
                                name: "CCOnboard",
                                state: {
                                  value: cardList,
                                  refNo: refNo,
                                  type: type,
                                  token: token,
                                },
                                query: {
                                  webFormRequestId: webFormRequestId.value,
                                },
                              });
                            } else {
                              router.push({
                                name: "Acknowledgement",
                                query: {
                                  status: "expired",
                                  refNo: refNo,
                                },
                              });
                            }
                          }
                        }
                      })
                      .catch((e) => {
                        router.push({
                          name: "Acknowledgement",
                          query: {
                            status: "cardTypeMissing",
                            refNo: "",
                          },
                        });
                      });
                  }
                }
              }
            }
          })
          .catch((e) => {
            router.push({
              name: "Acknowledgement",
              query: {
                status: "cardTypeMissing",
                refNo: "",
              },
            });
          });
      }
    } else {
      router.push({
        name: "Acknowledgement",
        query: {
          status: "invalidLink",
        },
      });
    }
  }
  // biometric without webFormRequestId
  else if (updatedParams.has("CC") && updatedParams.has("TYPE")) {
    cardId.value = updatedParams.get("CC") || "";
    type.value = updatedParams.get("TYPE") || "";
    // Create a URL object
    const url = new URL(currentUrl);
    url.search = "";
    // Update the CPC parameter
    url.searchParams.set("cc", cardId.value.toUpperCase());
    url.searchParams.set("type", type.value.toUpperCase());

    if (updatedParams.get("TYPE") == "BIO") {
      if (cardId.value == "" || cardId.value == "NA") {
        router.push({
          name: "CCOnboard",
          state: {
            type: type.value,
            url: url.toString(),
          },
          query: { cc: "NA", type: updatedParams.get("TYPE") },
        });
      } else {
        MasterService.cardType().then((res) => {
          cardTypeList.value = res.data.responseModel.cardTypeList;
          const cardObject = cardTypeList.value.find(
            (cardType) => cardType.code === cardId.value.toUpperCase(),
          );

          if (cardObject) {
            router.push({
              name: "CCOnboard",
              state: {
                type: type.value,
                url: url.toString(),
              },
              query: { cc: cardId.value, type: updatedParams.get("TYPE") },
            });
          } else {
            router.push({
              name: "Acknowledgement",
              query: {
                status: "cardTypeMissing",
                refNo: "",
              },
            });
          }
        });
      }
    }
  }
  // multichannel code handling
  else if (areAllParamsPresent(paramNames, updatedParams)) {
    multiChannelRequestModel.value.acc = updatedParams.get("ACC") || "";
    multiChannelRequestModel.value.bc = updatedParams.get("BC") || "";
    multiChannelRequestModel.value.rci = updatedParams.get("RCI") || "";
    multiChannelRequestModel.value.cpc = updatedParams.get("CPC") || "";
    multiChannelRequestModel.value.mci = updatedParams.get("MCI") || "";
    multiChannelRequestModel.value.mc = updatedParams.get("MC") || "";
    multiChannelRequestModel.value.crfn = updatedParams.get("CRFN") || "";

    // Create a URL object
    const url = new URL(currentUrl);
    url.search = "";
    // Update the CPC parameter
    url.searchParams.set(
      "ACC",
      multiChannelRequestModel.value.acc.toUpperCase(),
    );
    url.searchParams.set("BC", multiChannelRequestModel.value.bc.toUpperCase());
    url.searchParams.set(
      "RCI",
      multiChannelRequestModel.value.rci.toUpperCase(),
    );
    url.searchParams.set(
      "CPC",
      multiChannelRequestModel.value.cpc.toUpperCase(),
    );
    url.searchParams.set(
      "MCI",
      multiChannelRequestModel.value.mci.toUpperCase(),
    );
    url.searchParams.set("MC", multiChannelRequestModel.value.mc.toUpperCase());
    url.searchParams.set(
      "CRFN",
      multiChannelRequestModel.value.crfn.toUpperCase(),
    );

    const requestModel = {
      acc: multiChannelRequestModel.value.acc.toUpperCase(),
      bc: multiChannelRequestModel.value.bc.toUpperCase(),
      rci: multiChannelRequestModel.value.rci.toUpperCase(),
      cpc: multiChannelRequestModel.value.cpc.toUpperCase(),
      mci: multiChannelRequestModel.value.mci.toUpperCase(),
      mc: multiChannelRequestModel.value.mc.toUpperCase(),
      crfn: multiChannelRequestModel.value.crfn.toUpperCase(),
    };

    MasterService.linkValidation(requestModel)
      .then((res) => {
        if (res.status == 200) {
          if (res.data.responseModel.status != null) {
            router.push({
              name: "Acknowledgement",
              query: {
                status: "cardTypeMissing",
                refNo: "",
              },
            });
          } else if (res.data.responseModel.errorMessage != null) {
            router.push({
              name: "CCOnboard",
              state: {
                cc: "",
                type: "MC",
                url: url.toString(),
                error: [res.data.responseModel.errorMessage],
              },
              query: {
                ACC: res.data.responseModel.acc,
                BC: res.data.responseModel.bc,
                RCI: res.data.responseModel.rci,
                CPC: res.data.responseModel.cpc,
                MCI: res.data.responseModel.mci,
                MC: res.data.responseModel.mc,
                CRFN: res.data.responseModel.crfn,
              },
            });
          } else {
            router.push({
              name: "CCOnboard",
              state: {
                cc: res.data.responseModel.cpc,
                type: "MC",
                url: url.toString(),
              },
              query: {
                ACC: res.data.responseModel.acc,
                BC: res.data.responseModel.bc,
                RCI: res.data.responseModel.rci,
                CPC: res.data.responseModel.cpc,
                MCI: res.data.responseModel.mci,
                MC: res.data.responseModel.mc,
                CRFN: res.data.responseModel.crfn,
              },
            });
          }
        }
      })
      .catch((e) => {
        router.push({
          name: "Acknowledgement",
          query: {
            status: "cardTypeMissing",
            refNo: "",
          },
        });
      });
  }
  // multichannel code param missing
  else if (!areAllParamsPresent(paramNames, updatedParams)) {
    router.push({
      name: "Acknowledgement",
      query: {
        status: "cardTypeMissing",
        refNo: "",
      },
    });
  } else {
    router.push({
      name: "Acknowledgement",
      query: {
        status: "cardTypeMissing",
        refNo: "",
      },
    });
  }
};

onBeforeMount(() => {
  parseQueryString();
});
</script>

<style scoped></style>
